var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-popper',{staticClass:"ct-popover",attrs:{"trigger":_vm.trigger,"options":Object.assign({}, _vm.options,
    {modifiers: { offset: { offset: '0,10px' } }})}},[_c('div',{staticClass:"popper ct-popper"},[_vm._t("popper")],2),_vm._t("reference",null,{"slot":"reference"})],2)}
var staticRenderFns = []

export { render, staticRenderFns }